__turbopack_context__.v({
  "bottom": "MEI6Fa_bottom",
  "buttonLabel": "MEI6Fa_buttonLabel",
  "isSubmitting": "MEI6Fa_isSubmitting",
  "spinner": "MEI6Fa_spinner",
  "submitButton": "MEI6Fa_submitButton",
});
